export default __webpack_public_path__ + "static/media/Ico-complete.d9f3f7a3.svg";